module.exports = __webpack_public_path__ + "static/media/bottom_banner_12_2.1dae7d7e.png";